import React from 'react';
import { Circle, Path } from 'react-native-svg';
import { createIcon } from 'native-base';
export const LoadingIcon = createIcon({
    viewBox: '0 0 51 50',
    path: [
        React.createElement(Circle, { key: "circle", cx: "25.5", cy: "25", r: "22", stroke: "neutral.30", strokeWidth: 6, fill: "transparent" }),
        React.createElement(Path, { key: "path", d: "M50.5 25C50.5 20.3657 49.2119 15.8227 46.7795 11.8781C44.3471 7.93352 40.8661 4.74268 36.7253 2.66184C32.5844 0.581011 27.9467 -0.307901 23.33 0.0943595C18.7132 0.49662 14.2991 2.17422 10.5805 4.93985L14.1428 9.72957C16.9735 7.62429 20.3337 6.34724 23.8481 6.04103C27.3625 5.73482 30.8929 6.41148 34.045 7.99548C37.1972 9.57948 39.847 12.0085 41.6986 15.0112C43.5502 18.0139 44.5308 21.4723 44.5308 25H50.5Z", fill: "interactive.primary.active.default" }),
    ],
});
